import { z } from "zod"
import { CreateGroupMemberDtoSchema } from "@mimber/schema"

export const addMemberToGroupSchema = CreateGroupMemberDtoSchema.omit({
  membershipUuid: true,
}).extend({
  // Form-only field used to select a group / drive dependent role + dues
  // lookups. Not part of CreateGroupMemberDto — dropped before submit.
  groupUuid: z.string().uuid(),
  // DatePickerField clears to `null` (not `undefined`) when the date is
  // removed; normalize that to `undefined` so it's omitted from the
  // submitted payload rather than failing schema validation.
  duesFirstBillingDate: z
    .preprocess(
      (value) => (value === null ? undefined : value),
      CreateGroupMemberDtoSchema.shape.duesFirstBillingDate
    )
    .optional(),
})

export type AddMemberToGroupData = z.output<typeof addMemberToGroupSchema>
